import React from 'react';
import { AlertTriangle } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const EditPermissionNeeded = () => (
  <div className="ml-24 mb-24 ai-c d-f">
    <AlertTriangle className="llui-text-instrux-semibold mr-8" size={22} />
    <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
      {t('common.permission_to_edit')}
    </Text>
  </div>
);

export default EditPermissionNeeded;
